import { render, staticRenderFns } from "./FormTemplateFieldSelector.vue?vue&type=template&id=5c112e56&scoped=true&"
import script from "./FormTemplateFieldSelector.vue?vue&type=script&lang=js&"
export * from "./FormTemplateFieldSelector.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateFieldSelector.vue?vue&type=style&index=0&id=5c112e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c112e56",
  null
  
)

export default component.exports